<template>
    <ModalComponent
        :name="'enviar-' + base.id"
        title="Enviar deportista"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12 mb-2">
                <h5>Escriba el email donde quiere enviar el deportista</h5>
            </div>
            <div class="col-12">
                <FormInput label="Email" type="email" name="email" id="email" rules="required" v-model="email" />
            </div>
            <div class="col-12">
                <Button type="button" name="button" @click="enviarBase">ENVIAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['base'],
        data() {
            return {
                email: this.base.email
            }
        },
        methods: {
            enviarBase() {
                const params = {
                    filters : {},
                    lista_id: this.lista_id,
                    base_id: this.base.id,
                    email: this.email
                };

                this.$store.dispatch(this.config.getVuexAlias('back.bases.enviar'), params).then(res => {
                    this.$toast.success(res.data.message);
                });
                this.close();
            },
            close() {
                this.$emit('close', 'enviar-' + this.base.id);
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        components: { ModalComponent }
    }
</script>